import React from 'react'

import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const StyledDiv = styled.div<{ size: string; stroke?: string }>`
  animation: 2s ${rotate} linear infinite;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: ${({ stroke, theme }) => stroke || theme.v2.t01};
    font-size: ${({ size }) => size};
  }
`

/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */
export default function Loader({
  size = '16px',
  stroke,
  ...rest
}: {
  size?: string
  stroke?: string
  [k: string]: any
}) {
  return (
    <StyledDiv size={size} stroke={stroke} {...rest}>
      <i className="iconfont icon-loading"></i>
    </StyledDiv>
  )
}
